import React from 'react';


export const TableDisplay = ({headings, values, keys, name, onAdd, onRemove}) => {
    values = [...values];
    let text = '';
    if(values.length == 0)
        text = (<>Please add at least one {name}<br /></>);
    let thing = (
        <>
            {text}
            <button type="button" className="btn btn-primary" onClick={onAdd}>Add {name}</button>
        </>
    );
    values.push({name: thing});

    function mk_remove(ndx) {
        return (e) => onRemove(ndx);
    }
    
    let max_index = values.length - 1;

    function remove_button(ndx) {
        if(ndx >= max_index)
            return null;
        return (<button type="button" className="btn btn-warning" onClick={mk_remove(ndx)}>X</button>);
    }

    return (
        <div className="card border-info">
        <div className="card-header">
            {name}s
        </div>
        <div className="card-body">
        <table className="table">
        <thead>
            <tr>
                {headings.map((val, ndx) => (<th key={ndx}>{val}</th>))}
                <th></th>
            </tr>
        </thead>
        <tbody>
        {values.map((val, ndx) => (
            <tr key={ndx}>
                {keys.map((key, i) => (<td key={i}>{val[key]}</td>))}
                <td>
                    {remove_button(ndx)}
                </td>
            </tr>
        ))}
        </tbody>
        </table>
        </div>
        </div>
    );
}
